import "./password-reset.scss";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Header from "@components/elements/Header";
import useVerifySecurityCode from "@hooks/auth/useVerifySecurityCode";
import Loader from "@img/Loader.svg";
import { Link } from "@runwayhealth/runway-components-react";

import NewPasswordForm from "./components/NewPasswordForm";
import SecutryIcon from "./img/securty.svg";

type CodeParams = {
  token: string;
};

const TOKEN_EXPIRED = "jwt expired";

const PasswordResetPage = () => {
  const [authToken, setAuthToken] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { verifySecurityCode } = useVerifySecurityCode();
  const [errorMessage, setErrorMessage] = useState<string>("");

  const { token: resetToken } = useParams<CodeParams>();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await verifySecurityCode(resetToken);

      if (!result.token) {
        if (result?.response?.data?.message === TOKEN_EXPIRED) {
          setErrorMessage("Recovery link expired");
        } else {
          setErrorMessage("Could not recover password.");
        }
        setIsLoading(false);
        return;
      }

      setAuthToken(result.token);
      setIsLoading(false);
    })();
  }, [resetToken]);

  return (
    <>
      {" "}
      <Header hideBackButton={true} hasProgressBar={false} />
      <div>
        {authToken && resetToken ? (
          <div className="centered-form-container">
            <NewPasswordForm authToken={authToken} resetToken={resetToken} />
          </div>
        ) : (
          <div className="loader-wrapper">
            <div className="email-icon-container">
              <img className="email-icon" src={SecutryIcon} alt="aa" />
            </div>
            {isLoading && (
              <>
                {" "}
                <label className="waiting-message">
                  Please wait while we are processing your request
                </label>
                <div className="loader-img-container">
                  <img className="loader-img" src={Loader} />
                </div>
              </>
            )}
            {errorMessage && (
              <div className="error-message-code">
                <p className="message-content-login">{errorMessage}</p>
                <p>
                  <Link href="/login">Login</Link>
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default PasswordResetPage;
